function submitformUgc(formid, externalid, url) {
  var data = new FormData(jQuery('#' + formid + ' form')[0]);
  data.append("type", "formular");
  data.append("formularid", externalid);
  clearUGCFormErrors(formid);
  jQuery.ajax(url, {
    method: 'POST',
    processData: false,
    contentType: false,
    cache: false,
    data: data,
    dataType: 'json',
    success: function (data, textStatus, jqXHR) {
      if (parseUGCFormErrors(formid, data)) {
        var form = jQuery("#" + formid);
        form.addClass("form-success");
        form.html("<h2>Erfolgreich versendet</h2><p>Vielen Dank für Ihre Eingaben.</p>");
      } else {
        enableUGCSubmitButton();
      }
    },
    error: function (jqXHR, textStatus, error) {
      if (!parseUGCFormErrors(formid, error)) {
        var formerror = jQuery("#formerror-" + formid);
        formerror.html("Es ist leider ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.");
        formerror.attr("style", "");
      }
      enableUGCSubmitButton();
    }
  });
}

function checkVotingAnswerCount(votingId, numberOfVotes) {
  var button = jQuery("#formSubmitButton")[0];
  var error = jQuery("#votingerror" + votingId);
  if (jQuery('.answerInput:checked').length > numberOfVotes) {
    error.html("Bitte maximal "+numberOfVotes+" Antworten auswählen");
    button.disabled = true;
  } else {
    error.html("");
    button.disabled = false;
  }
}

function submitvotes(formId, votingId, resultUrl, sumbitUrl) {
  var data = jQuery('#voting-'+votingId+' form').serializeArray().reduce(function (obj, item) {
    if (item.name.startsWith('formField_')) {
      obj[item.name] = item.value;
    }
    return obj;
  }, {});
  resultUrl += '#';
  var allCheckedAnswers = jQuery('input[class=answerInput]:checked');
  for (var i = 0; i < allCheckedAnswers.length; i++) {
    var answerId = allCheckedAnswers[i].value;
    if (data['votingitem'] === undefined) {
      data['votingitem'] = answerId;
      resultUrl = resultUrl.concat(answerId);
    } else {
      data['votingitem'] = data['votingitem'].concat(',').concat(answerId);
      resultUrl = resultUrl.concat(',').concat(answerId);
    }
  }
  data['captchaIndex'] = jQuery('#'+formId+'-captchaIndex').val();
  data['captchaAnswer'] = jQuery('#'+formId+'-captchaAnswer').val();
  if (allCheckedAnswers.length === 0) {
    jQuery("#votingerror"+votingId).html("<p>Es muss eine Antwort ausgewählt werden</p>");
    enableUGCSubmitButton();
  } else {
    clearUGCFormErrors(votingId);
    jQuery("#votingerror"+votingId).html("");
    jQuery.ajax(sumbitUrl+"?"+new Date().getTime(), {
      method: 'POST',
      data: data,
      dataType: 'json',
      success: function (data, textStatus, jqXHR) {
        if (parseUGCFormErrors(formId, data)) {
          document.location.href = resultUrl;
        } else {
          enableUGCSubmitButton();
        }
      },
      error: function (jqXHR, textStatus, error) {
        jQuery("#votingerror" + votingId).html("Beim Abstimmen ist leider ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.");
        enableUGCSubmitButton();
      }
    });
  }
}

function checkQuizAnswer(questionIndex, iscorrect, internalId) {
  var answerDiv = jQuery('#userAnswer' + questionIndex);
  if (iscorrect) {
    answerDiv[0].innerText += "richtig!";
    answerDiv.addClass("right-answer");
  } else {
    answerDiv[0].innerText += "falsch!";
    answerDiv.addClass("wrong-answer");
  }
  jQuery('#question' + questionIndex).hide();
  jQuery('#explanation' + questionIndex).show();
  var solutionDiv = jQuery('#solution' + questionIndex);
  solutionDiv.addClass("form-group");
  solutionDiv.show();

  var answerElement = jQuery('#' + internalId);
  answerElement.addClass("answer-checked");
  if (!iscorrect) {
    answerElement.removeClass("quiz-no-answer").addClass("quiz-wrong-answer");
    jQuery('#sr-' + internalId)[0].innerText = "falsche Antwort:";
  }
}

function submitquiz(formId, quizId, questionExternalIds, quizUrl, submitUrl) {
  var data = jQuery('#' + quizId + ' form').serializeArray().reduce(function (obj, item) {
    if (item.name.startsWith('formField_')) {
      obj[item.name] = item.value;
    }
    return obj;
  }, {});

  data['questionids'] = questionExternalIds;
  quizUrl += '#';
  questionExternalIds.split(",").forEach(function (externalId, index) {
    var checkedAnswer = jQuery('input[name=formfield_answers' + index + ']:checked').val();
    if (index !== 0) {
      quizUrl = quizUrl.concat(',');
    }
    quizUrl = quizUrl.concat(checkedAnswer);
    data[externalId] = checkedAnswer;
  });
  data['captchaIndex'] = jQuery('#' + formId + '-captchaIndex').val();
  data['captchaAnswer'] = jQuery('#' + formId + '-captchaAnswer').val();
  clearUGCFormErrors(quizId);
  jQuery.ajax(submitUrl, {
    method: 'POST',
    data: data,
    dataType: 'json',
    success: function (data, textStatus, jqXHR) {
      if (parseUGCFormErrors(formId, data)) {
        document.location.href = quizUrl;
      } else {
        enableUGCSubmitButton();
      }
    },
    error: function (jqXHR, textStatus, error) {
      if (!parseUGCFormErrors(formId, error)) {
        var formerror = jQuery("#formerror-" + quizId);
        formerror.html("Es ist leider ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.");
        formerror.attr("style", "");
      }
      enableUGCSubmitButton();
    }
  });
}

function submitQuizPlayMode(formId, quizId, questionExternalIds, quizUrl) {
  quizUrl += '#';
  questionExternalIds.split(",").forEach(function (externalId, index) {
    if (index !== 0) {
      quizUrl = quizUrl.concat(',');
    }
    quizUrl = quizUrl.concat(jQuery('input[name=formfield_answers' + index + ']:checked').val());
  });
  document.location.href = quizUrl;
}

function clearUGCFormErrors(formid) {
  jQuery(".ugcerror").each(function (index, element) {
    element.parentNode.removeChild(element);
  });
  jQuery("#formerror-" + formid).attr("style", "display: none");
}

function parseUGCFormErrors(formid, data) {
  if (data.errorMessages !== undefined) {
    var errorMessages = data.errorMessages;
    for (var key in errorMessages) {
      jQuery("#" + formid + "-" + key).closest(".form-group").append("<p class=\"form-error ugcerror\">" + errorMessages[key] + "</p>");
    }
    var formerror = jQuery("#formerror-" + formid);
    formerror.html("Bitte korrigieren Sie Ihre Eingaben.");
    formerror.attr("style", "");
    return false;
  }
  return true;
}

function enableUGCSubmitButton() {
  var button = jQuery("#formSubmitButton")[0];
  button.disabled = false;
  button.textContent = "Abschicken";
}

function validateUGCForm() {
    var form = document.getElementById("inner-content-wrapper").querySelector('form');
    var errorFields = [];
    var formElements = form.elements;

    for (i = 0; i < formElements.length; i++) {
        var formElement = formElements[i];
        if (formElement.closest(".form-group-error") != null) {
            formElement.closest(".form-group").classList.remove("form-group-error");
        }
    }

    if (form.checkValidity() === false) {
        for (i = 0; i < formElements.length; i++) {
            formElement = formElements[i];
            if (formElement.checkValidity() === false) {
                formElement.closest(".form-group").classList.add("form-group-error");
                errorFields.push(formElement);
            }
        }
        if (errorFields.length > 0) {
            centerElement(errorFields[0]);
            errorFields[0].reportValidity();
        }
    }
}

function centerElement(element) {
    Element.prototype.documentOffsetTop = function () {
        return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0);
    };
    var top = element.documentOffsetTop() - (window.innerHeight / 2);
    window.scrollTo(0, top);
}
